<template>
  <div class="main">
    <!-- <el-breadcrumb separator="/" class="zy-div-breadcrumb" style="z-index:10;">
      <el-breadcrumb-item> <i class="fa fa-home"></i> 首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志</el-breadcrumb-item>
    </el-breadcrumb> -->
    <div class="container">
      <!-- 表单区域 -->
      <el-row class="apirow">
        <el-form size="medium" :model="form" ref="form" :rules="rules" label-width="90px" label-position="right">
          <el-row>
            <el-col :span="5">
              <el-form-item label="交易所" prop="exchange">
                <el-select v-model="form.exchange" placeholder="请选择交易所" @change="getNeedPass" filterable
                  style="width: 100%">
                  <el-option v-for="item in exchangeList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="apikey" prop="apikey">
                <el-input size="medium" v-model="form.apikey" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="passphrase" prop="passphrase">
                <el-input size="medium" v-model="form.passphrase" autocomplete="off"
                  :disabled="isdisabledFn"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="5">
              <el-form-item label="apiid" prop="apiid">
                <el-input size="medium" v-model="form.apiid" autocomplete="off" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="apiSecret" prop="apiSecret">
                <el-input size="medium" v-model="form.apiSecret" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="启用代理" prop="proxy">
                <el-select v-model="form.enableProxy" filterable allow-create default-first-option placeholder="请选择"
                  style="width: 100%">
                  <el-option v-for="item in proxyList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-button type="primary" @click="submitForm(form)">添加</el-button>
                <el-button @click="resetForm('form')">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </el-row>
      <!-- 表格区域 -->
      <el-row class="tablerow">
        <el-table :data="AfterChangeData" v-loading="bLoading">
          <el-table-column prop="apiid" label="apiid" width="220">
          </el-table-column>
          <el-table-column prop="apikey" label="apikey" width="220">
          </el-table-column>
          <el-table-column prop="exchangeName" label="交易所" width="220">
            <!-- <template slot-scope="scope">
              <span v-if="scope.row.exchange=='1'">KUCOIN</span>
              <span v-if="scope.row.exchange=='2'">OKEX</span>
              <span v-if="scope.row.exchange=='3'">BINANCE</span>
              <span v-if="scope.row.exchange=='4'">BITMART</span>
              <span v-if="scope.row.exchange=='5'">GATEIO</span>
              <span v-if="scope.row.exchange=='6'">BITRUE</span>
              <span v-if="scope.row.exchange=='7'">LBANK</span>
              <span v-if="scope.row.exchange=='8'">HUOBI</span>
              <span v-if="scope.row.exchange=='9'">COINONE</span>
              <span v-if="scope.row.exchange=='10'">MXC</span>
              <span v-if="scope.row.exchange=='11'">HOO</span>
              <span v-if="scope.row.exchange=='12'">COINW</span>
              <span v-if="scope.row.exchange=='13'">BITWELL</span>
              <span v-if="scope.row.exchange=='14'">BYBIT</span>
              <span v-if="scope.row.exchange=='15'">HITBTC</span>
          </template> -->
          </el-table-column>
          <el-table-column prop="proxy" label="启用代理" width="200">
            <template slot-scope="scope">
              {{ getProxyLabel(scope.row.proxy) }}
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize"
        layout="total,prev, pager, next" :total="tableData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import API from "./api.js";
import dbApiInfo from "@/proto/dbApiInfo_pb";
export default {
  name: "Api",
  data() {
    return {
      pageNum: 1, // 当前页
      pageSize: 10, // 每页显示条目数
      exchange: "",
      needPass: "",
      startDate: "",
      endDate: "",
      name: "",
      bLoading: false,
      msg: "Welcome to APiiiiiiiiiiiiiiiii",
      form: {
        apiid: "",
        apikey: "",
        apiSecret: "",
        exchange: "",
        passphrase: "",
        enableProxy: 0
      },
      proxyList: [],
      rules: {
        apiid: [{ required: true, message: "请输入apiid", trigger: "blur" }],
        apikey: [{ required: true, message: "请输入apikey", trigger: "blur" }],
        apiSecret: [
          { required: true, message: "请输入apiSecret", trigger: "blur" }
        ],
        exchange: [{ required: true, message: "请输入交易所", trigger: "blur" }]
      },
      tableData: [],
      exchangeList: []
    };
  },
  computed: {
    key() {
      return this.$route.path + new Date().getTime();
    },
    // 分页
    AfterChangeData() {
      let start = (this.pageNum - 1) * this.pageSize;
      let end = this.pageNum * this.pageSize;
      return this.tableData.slice(start, end);
    },
    // 控制passphrase状态
    isdisabledFn() {
      if (this.needPass === true) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    // 获取表格数据
    getTableData() {
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      API.getApiList(data)
        .then(res => {
          if (res.data.errcode === 0) {
            // console.log("--------------"+JSON.stringify(res.data))
            var buffer = res.data.buffer;
            var message = dbApiInfo.DbApiList.deserializeBinary(buffer);
            // console.log("message=", message);
            var apiArray = [];
            // console.log("exchangeList=", this.exchangeList);
            message.getApisList().forEach(api => {
              // console.log("api=", api);
              // console.log("exchangeList=", this.exchangeList);
              this.exchangeList.forEach(exchange => {
                // console.log("exchange=", exchange);
                if (api.getExchangeid() === exchange.id) {
                  var apiObj = {
                    apiid: api.getApiid(),
                    apikey: api.getApikey(),
                    apiSecret: api.getApisecret(),
                    exchange: api.getExchangeid(),
                    exchangeName: exchange.name,
                    proxy: api.getEnableproxy()
                  };
                  apiArray.push(apiObj);
                }
              });
            });
            // console.log("apiArray=", apiArray);
            this.tableData = apiArray;
          } else {
            console.log(
              "getApiListMsg=",
              res.data.errcode + "-" + res.data.errmsg
            );
            this.$message.error(res.data.errcode + "-" + res.data.errmsg);
            if (res.data.errcode === 3001) {
              // 无效的登录凭证
              this.$router.push("/adminLogin");
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$router.push("/adminLogin");
          // this.$message.error(res.data.errcode + '-' + res.data.errmsg)
          this.$message.error(err);
        });
    },
    // 获取exchange
    async getExchangesList() {
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      const res = await API.getExchangesList(data);
      // console.log("--------------"+JSON.stringify(res.data))
      if (res.data) {
        this.exchangeList = res.data;
      } else {
        console.log(
          "getExchangesListMsg=",
          res.data.errcode + "-" + res.data.errmsg
        );
        this.$message.error(res.data.errcode + "-" + res.data.errmsg);
        if (res.data.errcode === 3001) {
          // 无效的登录凭证
          this.$router.push("/adminLogin");
        }
      }
      // API.getExchangesList(data).then(res => {
      //   console.log("--------------"+JSON.stringify(res.data))
      //   if (res.data) {
      //     this.exchangeList = res.data;
      //   } else {
      //     console.log(
      //       "getExchangesListMsg=",
      //       res.data.errcode + "-" + res.data.errmsg
      //     );
      //     this.$message.error(res.data.errcode + "-" + res.data.errmsg);
      //     if (res.data.errcode === 3001) {
      //       // 无效的登录凭证
      //       this.$router.push("/adminLogin");
      //     }
      //   }
      // });

      // this.getTableData();
    },
    getNeedPass() {
      this.exchangeList.forEach(item => {
        if (this.form.exchange === item.id) {
          this.needPass = item.needPass;
        }
      });
    },
    // 当前页数改变
    handleCurrentChange(val) {
      this.pageNum = val;
    },
    // 创建新api
    submitForm(form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            apiId: form.apiid.trim(),
            apiKey: form.apikey.trim(),
            apiSecret: form.apiSecret.trim(),
            exchange: form.exchange,
            passphrase: form.passphrase.trim(),
            enableProxy: form.enableProxy
          };
          API.CreateApi(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.getTableData();
                this.$message({
                  message: "创建成功！",
                  type: "success"
                });
                this.resetForm();
              } else {
                this.$message.error(res.data.errcode + "-" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "创建失败！" + error,
                type: "error"
              });
              // this.resetForm();
              // console.log(error.response.data.errcode)
            });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
    },
    // 删除api
    handleDelete(index, row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            apiId: row.apiid
          };
          API.DeleteApi(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.getTableData();
                this.$message({
                  message: "删除成功！",
                  type: "success"
                });
              } else {
                this.$message.error(res.data.errcode + "-" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "删除失败！" + error,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    async getProxiesList() {
      try {
        const res = await API.GetProxies({ uid: localStorage.getItem("admin-uid") });
        console.log("--------------" + JSON.stringify(res))
        if (res.data && res.data && res.data.length > 0) {
          // 添加"无"选项
          this.proxyList = [{ value: 0, label: '无' }, ...res.data.map(item => ({
            value: item.id,
            label: item.id + ":" + item.proxy
          }))];
        } else {
          this.proxyList = [{ value: 0, label: '无' }];
        }
      } catch (error) {
        console.error('获取代理列表失败:', error);
        this.proxyList = [{ value: 0, label: '无' }];
      }
    },
    getProxyLabel(proxyValue) {
      const proxyItem = this.proxyList.find(item => item.value == proxyValue);
      return proxyItem ? proxyItem.label : '--';
    }
  },
  async created() {
    await this.getExchangesList();
    await this.getProxiesList();
    this.getTableData();
    this.getNeedPass();
  }
};
</script>

<style scoped>
@import "../assets/css/apiman.scss";
</style>
